import type { MessageKey } from '../../../../src/messages/types';

export const MESSAGE_KEY_ORDER: readonly MessageKey[] = [
  'greeting',
  'message1',
  'message2',
  'message3',
  'message4',
  'message5',
  'message6',
  'message7',
  'message8',
  'message9',
  'messagePhoneTypo',
  'messageOptOutLinked',
  'messageOptOutMissed',
];

export const MESSAGE_DESCRIPTIONS: Record<MessageKey, string> = {
  greeting: 'あいさつメッセージ',
  message1: '電話・メール見つからず1',
  message2: '電話・メール見つからず2',
  message3: '電話・メール見つからず3',
  message4: 'LINE連携済みの方（未使用）',
  message5: 'エントリー以降、新規',
  message6: 'エントリー以降、プラン提案あり',
  message7: 'プラン予約済み',
  message8: 'キャンセル済み',
  message9: 'フォーム誘導後エントリー',
  messagePhoneTypo: '電話番号の桁数エラー',
  messageOptOutLinked:
    '「案内不要」カテゴリ判定後、電話/メールから紐付け成功時 (SF Stage 更新済み)',
  messageOptOutMissed:
    '「案内不要」カテゴリ判定後、紐付けできなかった場合 (担当者へエスカレーション)',
};

export const KEYS_WITH_SF: ReadonlySet<MessageKey> = new Set<MessageKey>([
  'message4',
  'message5',
  'message6',
  'message7',
  'message8',
  'message9',
]);
